export type SellerDetails = {
    description: string;
    email: string;
    phoneNumber: string;
    sellerId: number;
    // url to the seller's website
    website: string;
};

export const emptySellerDetails: SellerDetails = {
    description: '',
    email: '',
    phoneNumber: '',
    sellerId: 0,
    website: '',
};
